<div class="welcome-container">
  <div class="welcome-header">
    @if (config()?.iconUrl && !_iconLoadError()) {
      <img
        class="welcome-icon"
        [src]="config()?.iconUrl"
        alt=""
        (error)="_onIconError()"
      />
    } @else if (config()?.icon || _iconLoadError()) {
      <span class="welcome-icon-emoji">{{ config()?.icon ?? '💬' }}</span>
    }

    @if (welcomeMessage()) {
      <h2 class="welcome-message">{{ welcomeMessage() }}</h2>
    }
  </div>

  @if (suggestions().length) {
    <div class="suggestions-list">
      @for (suggestion of suggestions(); track suggestion.text) {
        <button
          type="button"
          class="suggestion-button"
          (click)="onSuggestionClick(suggestion)"
        >
          <span class="suggestion-icon">{{ suggestion.icon ?? '💬' }}</span>
          <span class="suggestion-text">{{ suggestion.text }}</span>
        </button>
      }
    </div>
  }
</div>
